import {parseNumber} from '@benchling/js-utils';

export interface NumericInputValidationParams {
  value: string | number | null | undefined;
  required: boolean;
  validateInteger: boolean;
  min?: number;
  minIsInclusive: boolean;
  max?: number;
  maxIsInclusive: boolean;
}

export function getNumericValidationError({
  value,
  required,
  validateInteger,
  min,
  minIsInclusive,
  max,
  maxIsInclusive,
}: NumericInputValidationParams): string | null {
  if (value == null || value === '') {
    return required ? 'Value must be specified' : null;
  }

  const numericValue = typeof value === 'number' ? value : parseNumber(value);
  if (numericValue == null) {
    return 'Value must be a number';
  }
  if (validateInteger && !Number.isInteger(numericValue)) {
    return 'Value must be an integer';
  }
  if (min != null && (minIsInclusive ? numericValue < min : numericValue <= min)) {
    return minIsInclusive
      ? `Value must be greater than or equal to ${min}`
      : `Value must be greater than ${min}`;
  }
  if (max != null && (maxIsInclusive ? numericValue > max : numericValue >= max)) {
    return maxIsInclusive ? `Value must be less than or equal to ${max}` : `Value must be less than ${max}`;
  }
  return null;
}

export function isInvalidNumericValue(params: NumericInputValidationParams): boolean {
  return getNumericValidationError(params) != null;
}
